// extracted by mini-css-extract-plugin
export var textInput = "_ek-0";